module.exports = __webpack_public_path__ + "static/media/icon-gear.82fd7eb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-gear.svg
// module id = 1497
// module chunks = 0